import { autocomplete } from "@algolia/autocomplete-js";
import { debounced } from "./debounce";
import { getCaseItemTemplate } from "./templates/caseitem";
import { getEmployeeTemplate } from "./templates/employee";
import { getInvoiceTemplate } from "./templates/invoice";
import { getPhonePlanTemplate } from "./templates/phone_plan";
import { getRentalTemplate } from "./templates/rental";
import { getOrganisationTemplate } from "./templates/organisation";
import { getUrl, handleGlobalSearchClick } from "./utils";
import { getReturnCaseTemplate } from "./templates/return_case";

autocomplete({
  container: "#global-searchbox",
  placeholder: "Search for a device, employee or phone plan...",
  openOnFocus: true,

  async getSources({ query }) {
    return debounced([
      {
        sourceId: "globalsearch",
        async getItems() {
          if (query.length < 3) {
            return [];
          }
          const results = await fetch(
            `/admin/global-search/search?search=${encodeURIComponent(query)}`
          );
          return await results.json();
        },
        onSelect({ event, item }) {
          const itemUrl = getUrl(item);
          event.preventDefault();
          if (event.type === "click") {
            if (event.ctrlKey || event.metaKey) {
              const windowReference = window.open(
                itemUrl,
                "_blank",
                "noopener"
              );
              if (windowReference) {
                windowReference.focus();
              }
            } else {
              window.location.assign(itemUrl);
            }
          }
        },
        templates: {
          item({ item, html }) {
            if (item.document.hasOwnProperty("organisation.id")) {
              return getOrganisationTemplate(item, html);
            }
            if (item.document.hasOwnProperty("rental.id")) {
              return getRentalTemplate(item, html);
            }
            if (item.document.hasOwnProperty("employee.id")) {
              return getEmployeeTemplate(item, html);
            }
            if (item.document.hasOwnProperty("case_item.id")) {
              return getCaseItemTemplate(item, html);
            }
            if (item.document.hasOwnProperty("phone_plan.id")) {
              return getPhonePlanTemplate(item, html);
            }
            if (item.document.hasOwnProperty("invoice.id")) {
              return getInvoiceTemplate(item, html);
            }
            if (item.document.hasOwnProperty("return_case.id")) {
              return getReturnCaseTemplate(item, html);
            }
            return "N/A";
          },
          noResults() {
            return "We didnt find a match, please enter more than 3 chars";
          },
        },
        getItemUrl({ item }) {
          return getUrl(item);
        },
      },
    ]);
  },
});
